import React, { useRef } from "react";
import { cn } from "tailwind-variants";
import UseSvg from "common/vue/components/UseSvg.react.vue";

export default function ArtistEditsHeader({
  title,
  onHowItWorksClick,
  onHowItWorksMouseenter,
  onHowItWorksMouseleave,
  ...restProps
}) {
  const howItWorksButtonRef = useRef(null);

  return (
    <div {...restProps} className={cn("flex items-center gap-1.5")}>
      <UseSvg className={cn("h-4 w-4 shrink-0")} icon="sparkles-gradient" data-testid="h-4" />
      <h3 className={cn("text-sm !font-medium leading-6 text-neutral-950")}>{title}</h3>
      <span
        className={cn(
          "rounded-full border border-white bg-green-700 px-1.5 py-0.5 text-xs font-medium text-white"
        )}
      >
        {" "}
        Free{" "}
      </span>
      <div className={cn("ml-auto")}>
        <button
          className={cn(
            "cursor-pointer border-0 bg-transparent p-0 text-xs !text-blue-700 underline"
          )}
          ref={howItWorksButtonRef}
          type="button"
          data-testid="how-it-works-button"
          onClick={() => {
            onHowItWorksClick?.();
          }}
          onMouseEnter={() => {
            onHowItWorksMouseenter?.();
          }}
          onMouseLeave={() => {
            onHowItWorksMouseleave?.();
          }}
        >
          {" "}
          How it works{" "}
        </button>
      </div>
    </div>
  );
}
